__turbopack_context__.v({
  "ageBugDrag": "SharpnessStory-module-scss-module__ZqezSa__ageBugDrag",
  "chart": "SharpnessStory-module-scss-module__ZqezSa__chart",
  "chartWrapper": "SharpnessStory-module-scss-module__ZqezSa__chartWrapper",
  "fade-in": "SharpnessStory-module-scss-module__ZqezSa__fade-in",
  "inner": "SharpnessStory-module-scss-module__ZqezSa__inner",
  "isPage": "SharpnessStory-module-scss-module__ZqezSa__isPage",
  "items": "SharpnessStory-module-scss-module__ZqezSa__items",
  "masthead": "SharpnessStory-module-scss-module__ZqezSa__masthead",
  "root": "SharpnessStory-module-scss-module__ZqezSa__root",
  "scrollRoot": "SharpnessStory-module-scss-module__ZqezSa__scrollRoot",
  "sideBarLines": "SharpnessStory-module-scss-module__ZqezSa__sideBarLines",
  "sideBarLinesWrap": "SharpnessStory-module-scss-module__ZqezSa__sideBarLinesWrap",
});
